import { ReportsComponent } from './reports.component';
import { RoleGuard } from '../shared/core/role-guard.service';

export const routes = [
    { path: 'reports',component:ReportsComponent,
    canActivate: [RoleGuard], 
    data: { roles: [process.env.CLEARANCE_ROLE, process.env.PRODUCTION_ROLE]}}
];



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/reports/reports.routes.ts